import React, { forwardRef } from "react";
import "./Button.scss";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  loading?: boolean;
  label?: string;
  bgColor?: string;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = "primary",
      size = "md",
      icon,
      iconPosition = "left",
      label,
      loading = false,
      disabled,
      bgColor,
      className = "",
      ...rest
    },
    ref
  ) => {
    const isDisabled = disabled || loading;

    const classes = [
      "cg-btn",
      `cg-btn--${variant}`,
      `cg-btn--${size}`,
      "p-3",
      icon ? "cg-btn--with-icon" : "",
      loading ? "cg-btn--loading" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        className={classes}
        disabled={isDisabled}
        style={{
          backgroundColor: bgColor ?? "primary",
        }}
        {...rest}
      >
        {label ? <span className="cg-btn__label">{label}</span> : null}
        {loading ? (
          <span className="cg-btn__spinner" aria-hidden="true" />
        ) : null}
        {icon && iconPosition === "left" ? (
          <span className="cg-btn__icon cg-btn__icon--left">{icon}</span>
        ) : null}
        <span className="cg-btn__label">{children}</span>
        {icon && iconPosition === "right" ? (
          <span className="cg-btn__icon cg-btn__icon--right">{icon}</span>
        ) : null}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
